import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import { Button } from 'app/src/elements/buttons';

import { cardStyles as styles } from './index';
import { SEND_BUYER_SUMMARY_REPORT } from './queries';

const BuyerSummaryReport = ({ data }) => {
  const [buyerId, setBuyerId] = useState();
  const [saleId, setSaleId] = useState();
  const [includeBOS, setIncludeBOS] = useState(false);

  const [sendBuyerSummaryReport] = useMutation(SEND_BUYER_SUMMARY_REPORT);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'buyer-summary-report',
      params: {
        'sale-id': saleId, 'buyer-id': buyerId, 'include-bos': includeBOS
      },
    })
  };

  const handleEmail = () => {
    if (!saleId) { return; }

    const confirmation = buyerId ?
      'Email Buyer Summary Report to buyer?' :
      'Email Buyer Summary Report to all buyers of assets in this sale?';

    if (confirm(confirmation)) {
      sendBuyerSummaryReport({
        variables: { buyerId, saleId, includeBOS }
      });
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Buyer Summary Report</Text>
      <Text style={styles.label}>Buyer:</Text>
      <select
        style={styles.select}
        onChange={(e) => setBuyerId(e.target.value)}
      >
        <optgroup label="Selection">
          <option value="">Select Buyer</option>
          {data.buyers?.map(buyer => (
            <option key={buyer.id} value={buyer.id}>
              {buyer.fullDisplayName}
            </option>
          ))}
        </optgroup>
      </select>
      <Text style={styles.label}>Sale:</Text>
      <select style={styles.select} onChange={(e) => setSaleId(e.target.value)}>
        <option key="sale-nil" value="">Select Sale</option>
        {data.sales?.map(sale => (
          <option key={sale.id} value={sale.id}>
            {sale.name}
          </option>
        ))}
      </select>
      <View style={{flexDirection: 'row'}}>
        <input
          type="checkbox"
          checked={includeBOS}
          onChange={e => setIncludeBOS(e.target.checked)}
        />
        <Text>Include Bills of Sale (PDF Only)</Text>
      </View>
      <DownloadButton handleDownload={handleDownload}>
        <Button
          label="Email"
          style={
            saleId ? { width: 120 } : { backgroundColor: 'gray', width: 120 }
          }
          onPress={handleEmail}
        />
      </DownloadButton>
    </View>
  )
}

export default BuyerSummaryReport;
